import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { usePWAInstall } from "./PWAInstallContext";

/**
 * Floating install banner for the marketing landing-page flow (?install=1).
 * Settings uses PWAInstallSettingsRow instead.
 */
export default function PWAInstallBanner() {
  const { canInstall, install, bannerDismissed, dismissBanner } = usePWAInstall();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setReady(true), 1500);
    return () => clearTimeout(timer);
  }, []);

  const fromLandingPage = new URLSearchParams(location.search).get("install") === "1";
  const shouldShow = fromLandingPage && canInstall && !bannerDismissed && ready;

  if (!shouldShow) return null;

  return (
    <div className="pwa-install-banner">
      <div className="pwa-install-banner__icon">
        <img src="/icon128.png" alt="Task Mantis" />
      </div>

      <div className="pwa-install-banner__text">
        <div className="pwa-install-banner__title">Install Task Mantis App</div>
        <div className="pwa-install-banner__desc">
          Add to your desktop — opens like a native app
        </div>
      </div>

      <button type="button" className="pwa-install-banner__install-btn" onClick={() => void install()}>
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" aria-hidden="true">
          <path d="M21 15v4a2 2 0 01-2 2H5a2 2 0 01-2-2v-4M7 10l5 5 5-5M12 15V3" />
        </svg>
        Install
      </button>

      <button
        type="button"
        className="pwa-install-banner__dismiss-btn"
        onClick={dismissBanner}
        aria-label="Dismiss install banner"
      >
        ×
      </button>
    </div>
  );
}
